window.axios = require("axios");
window.url = "";
// if (process.env.NODE_ENV == "production")
    window.axios.defaults.baseURL = process.env.VUE_APP_API;
window.axios.defaults.headers.common["Access-Control-Allow-Origin"], "*";
window.axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
window.axios.defaults.headers.put["Content-Type"] = "multipart/form-data";
